export default {"src":"/_next/static/media/dropdown.6378b50e.svg","height":13,"width":12,"blurWidth":0,"blurHeight":0};